import { render } from "./NotificationDetailVx.vue?vue&type=template&id=78eb9c0a"
import script from "./NotificationDetailVx.vue?vue&type=script&lang=js"
export * from "./NotificationDetailVx.vue?vue&type=script&lang=js"

import "./NotificationDetailVx.vue?vue&type=style&index=0&id=78eb9c0a&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__